import classNames from 'classnames';
import type React from 'react';
import '@css/not-activated.css';

type NotActivatedOverlayProps = React.HTMLAttributes<HTMLDivElement>;

export function NotActivatedOverlay({ className, ...props }: NotActivatedOverlayProps) {
  return <div className={classNames('not-activated', className)} {...props} />;
}
